/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AssociatedcompanyPartnersDropdown200,
  GetApiV1AssociatedcompanyPartnersDropdown401,
  GetApiV1AssociatedcompanyPartnersDropdown500,
  GetApiV1AssociatedcompanyPartnersDropdownQueryParams,
  GetApiV1AssociatedcompanyPartnersDropdownQueryResponse,
} from "../../types/associatedCompanySharedController/GetApiV1AssociatedcompanyPartnersDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1AssociatedcompanyPartnersDropdownQueryParamsSchema = z
  .object({
    filter: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1AssociatedcompanyPartnersDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AssociatedcompanyPartnersDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1AssociatedcompanyPartnersDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AssociatedcompanyPartnersDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyPartnersDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AssociatedcompanyPartnersDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyPartnersDropdown500>;

export const getApiV1AssociatedcompanyPartnersDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1AssociatedcompanyPartnersDropdown200Schema,
  ) as unknown as ToZod<GetApiV1AssociatedcompanyPartnersDropdownQueryResponse>;
